import { useState } from "react";
import { Ban, CreditCard, FileText, Loader2, Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import OrderEditDialog from "@/components/admin/OrderEditDialog";

export default function PendingOrderActions({ order, onChanged }) {
  const [busy, setBusy] = useState("");
  const [edit, setEdit] = useState(false);
  const sid = order.session_id;
  const isCheque = order.payment_status === "awaiting_cheque";

  const call = (key, fn) => async () => {
    setBusy(key);
    try { await fn(); } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Action impossible"); } finally { setBusy(""); }
  };
  const pay = (method) => call(method, async () => {
    const { data } = await api.post(`/customer/orders/${sid}/pay`, { method, origin_url: window.location.origin });
    if (data.url) { window.location.href = data.url; return; }
    toast.success("Commande passée en paiement par chèque : les instructions vous ont été envoyées par e-mail");
    onChanged();
  });
  const cancel = call("cancel", async () => {
    if (!window.confirm("Annuler définitivement cette commande ?")) return;
    const { data } = await api.post(`/customer/orders/${sid}/cancel`);
    toast.success(data.message);
    onChanged();
  });

  const btn = "inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-semibold transition-colors disabled:opacity-60";
  const spin = (k, Icon) => (busy === k ? <Loader2 size={13} className="animate-spin" /> : <Icon size={13} />);
  return (
    <div data-testid={`pending-actions-${sid}`} className="mt-4 rounded-xl bg-amber-50 p-4">
      <p className="text-sm font-medium text-bark">{isCheque ? "Nous attendons votre chèque. Vous pouvez aussi payer en ligne ou modifier votre commande." : "Cette commande n'est pas encore réglée."}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button data-testid={`pending-pay-paypal-${sid}`} disabled={!!busy} onClick={pay("paypal")} className={`${btn} bg-amber-deep text-white hover:bg-honey`}>{spin("paypal", CreditCard)} Payer maintenant (carte / PayPal)</button>
        {!isCheque && <button data-testid={`pending-pay-cheque-${sid}`} disabled={!!busy} onClick={pay("cheque")} className={`${btn} border border-amber-800/25 bg-white text-bark hover:border-amber-deep`}>{spin("cheque", FileText)} Payer par chèque</button>}
        <button data-testid={`pending-edit-${sid}`} disabled={!!busy} onClick={() => setEdit(true)} className={`${btn} border border-amber-800/25 bg-white text-bark hover:border-amber-deep`}><Pencil size={13} /> Modifier ma commande</button>
        <button data-testid={`pending-cancel-${sid}`} disabled={!!busy} onClick={cancel} className={`${btn} text-terra hover:bg-terra/10`}>{spin("cancel", Ban)} Annuler</button>
      </div>
      {edit && <OrderEditDialog customer order={order} onClose={() => setEdit(false)} onSaved={() => { setEdit(false); onChanged(); }} />}
    </div>
  );
}
